import React from 'react';
import dogIconBlack from '../assets/dogIconBlack.svg';
import catIconBlack from '../assets/catIconBlack.svg';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer';
import { Link } from '@reach/router';
import { Image } from 'bloomer/lib/elements/Image';
import styled from 'styled-components';

const CenteredImage = styled(Image)`
  margin: 0 auto;
`;

const CenteredTitle = styled(Title)`
  text-align: center;
`;

const PopOnHover = styled(Link)`
  .box {
    transition: all 0.2s;
  }

  &:hover .box {
    transform: scale(1.1);
  }
`;

interface PropTypes {
  path: string;
}

const Directory = (props: PropTypes) => {
  return (
    <Container>
      <Box>
        <Title id="directoryPageHeading" tag="h1" isSize={2}>
          The Directory Page
        </Title>
        <p className="is-size-3">Select the list you would like to load:</p>
      </Box>
      <Columns>
        <Column>
          <PopOnHover to="/list/dog">
            <Box>
              <CenteredTitle tag="h2" isSize={2}>
                Dogs
              </CenteredTitle>
              <CenteredImage isSize="128x128" src={dogIconBlack} alt="The dog list" />
            </Box>
          </PopOnHover>
        </Column>
        <Column>
          <PopOnHover to="/list/cat">
            <Box>
              <CenteredTitle tag="h2" isSize={2}>
                Cats
              </CenteredTitle>
              <CenteredImage isSize="128x128" src={catIconBlack} alt="The Cat List" />
            </Box>
          </PopOnHover>
        </Column>
      </Columns>
    </Container>
  );
};

export default Directory;
